<template>
  <footer class="footer">
    <router-link :to="{name: 'about'}">
      Wer wir sind
    </router-link>
    <router-link :to="{name: 'datenschutz'}">
      Datenschutz
    </router-link>
    <a href="mailto:kontakt@wersglaubt_SPAMPROTECTION_.at" onclick="this.href=this.href.replace(/_SPAMPROTECTION_/,'')">
      Kontakt
    </a>
    <a href="https://sinndeslebens.at" target="_blank">
      SINNDESLEBENS.AT
    </a>
    <a href="https://wersglaubt.at/youtube" target="_blank">
      <img src="@/assets/youtube.svg" class="youtube-logo">
    </a>
    <!--<p class="recaptcha">Wir benutzen reCAPTCHA von Google. Dies unterliegt der <a href="https://www.google.com/intl/en/policies/privacy/">Datenschutzerklärung</a> und den <a href="https://www.google.com/intl/en/policies/terms/">Nutzungsbedingungen</a> von Google.</p>-->
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped lang="scss">
.footer {
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 10px;

  a {
    color: black;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 600;

    margin-left: 10px;
    margin-right: 10px;

    &:visited {
      color: black;
    }
  }

  .youtube-logo {
    height: 50px;
    position: relative;
    top: 20px;
  }

  .recaptcha {
    $fontSize: 10px;

    font-size: $fontSize;
    margin-top: 10px;

    a {
      font-size: $fontSize;
      font-weight: 600;
    }
  }
}
</style>
